import { createSelector } from "reselect";

import { selectOpportunityListsWithoutRecentlyViewed } from "app/pages/sales-intelligence/sub-modules/account-review/AddToListButton/selectors";
import { selectOpportunityLists } from "app/pages/sales-intelligence/sub-modules/opportunities/store/selectors";
import { OpportunityListTypeEnum } from "app/pages/sales-intelligence/sub-modules/opportunities/types";

export const selectDisabledListNames = (domain: string) =>
    createSelector(selectOpportunityLists, (opportunityLists) => {
        return opportunityLists.reduce<string[]>((acc, list) => {
            const isWebsiteInList = list.opportunities.includes(domain);
            if (isWebsiteInList || list.listType === OpportunityListTypeEnum.RecentlyViewed) {
                acc.push(list.opportunityListId);
            }
            return acc;
        }, []);
    });

export const selectAlreadyInList = (domain: string) =>
    createSelector(selectOpportunityListsWithoutRecentlyViewed, (opportunityLists) =>
        opportunityLists.reduce<string[]>((acum, { opportunities, friendlyName }) => {
            const present = opportunities.includes(domain);
            return present ? [...acum, friendlyName] : acum;
        }, []),
    );
